import { Component, input, output } from "@angular/core";
import { IonIcon, IonImg } from "@ionic/angular/standalone";

import { BaseComponent } from "@mp/common/base/base.component";
import { UserEntity } from "@mp/common/entities/user.entity";
import { InitialsPipe } from "@mp/common/pipes/initials.pipe";

@Component({
    selector: "mp-user-avatar",
    templateUrl: "./user-avatar.component.html",
    styleUrls: ["./user-avatar.component.scss"],
    imports: [IonImg, IonIcon, InitialsPipe],
    host: {
        "[class.is-removable]": "removable()",
        "[class.is-selected]": "selected()"
    }
})
export class UserAvatarComponent extends BaseComponent {
    public readonly user = input.required<UserEntity>();
    public readonly removable = input<boolean>(false);
    public readonly selected = input<boolean>(false);

    public readonly removed = output<void>();

    constructor() {
        super();
    }

    public remove(): void {
        this.removed.emit();
    }
}
